module.exports = __webpack_public_path__ + "img/l-08.8f777bef.png";